/**
 * Main entry file for the english translation.
 */

// This is an example import of an view(component).
import admin from './components/admin'
import audits from './components/audits'
import auth from './components/auth'
import backup from './components/backup'
import breadcrumb from './components/breadcrumb'
import config from './components/config'
import dashboard from './components/dashboard'
import icon from './components/icon'
import log from './components/log'
import navigation from './components/navigation'
import site from './components/site'
import sites from './components/sites'
import updates from './components/updates'
import user from './components/user'
import toolbox from './components/toolbox'
import extensions from './components/extensions'
import tag from './components/tag'
import clientmodal from './components/clientmodal'
import tableheadings from './components/tableheadings'
import emptylist from './components/emptylist'

const en = {
  admin,
  audits,
  auth,
  backup,
  breadcrumb,
  config,
  dashboard,
  icon,
  log,
  navigation,
  site,
  sites,
  updates,
  user,
  toolbox,
  extensions,
  tag,
  clientmodal,
  tableheadings,
  emptylist
}

export default en
